import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LogInButtons from 'flarum/forum/components/LogInButtons';
function getProviders() {
  const providersJson = app.forum.attribute('floxum-oidc.providers');

  // Safety check: verify it is a valid string before parsing
  if (!providersJson || typeof providersJson !== 'string') return {};
  try {
    return JSON.parse(providersJson) || {};
  } catch (e) {
    console.error('Floxum OIDC: Invalid JSON settings', e);
    return {};
  }
}

/**
 * Flarum 2 authenticates with a full-page redirect: the server sends the user
 * back to `returnTo` once the identity provider is done.
 */
function authUrl(key) {
  const returnTo = window.location.pathname + window.location.search;
  return `${app.forum.attribute('baseUrl')}/auth/oidc?provider=${encodeURIComponent(key)}&returnTo=${encodeURIComponent(returnTo)}`;
}

/**
 * Core's ResponseFactory redirects new users back with `?_flarum_auth=<token>`
 * (and linked users with `?_flarum_linked=<provider>`), but leaves opening the
 * sign-up modal to the auth extension. FoF OAuth does the same thing, so only
 * handle it here when that extension is not installed.
 */
function handleAuthRedirect() {
  if (app.initializers.has('fof/oauth')) return;
  const params = new URLSearchParams(window.location.search);
  const token = params.get('_flarum_auth');
  if (!token && !params.has('_flarum_linked')) return;
  params.delete('_flarum_auth');
  params.delete('_flarum_linked');
  const query = params.toString();
  window.history.replaceState({}, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
  if (!token) return;

  // Deferred until boot has finished: the session and modal manager don't exist yet.
  setTimeout(async () => {
    if (app.session && app.session.user) return;
    let attrs = {
      token
    };
    try {
      const data = await app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/registration-token`,
        body: {
          token
        }
      });
      attrs = {
        token,
        username: data.username || '',
        email: data.email || '',
        provided: data.provided || []
      };
    } catch (e) {
      // An expired token still opens the modal; submitting it shows the error.
    }
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'), attrs);
  }, 0);
}
app.initializers.add('floxum-oidc', () => {
  extend(LogInButtons.prototype, 'items', function (items) {
    // WRAP IN TRY-CATCH to prevent crashing other extensions (like fof/oauth)
    try {
      const providers = getProviders();
      Object.keys(providers).forEach(key => {
        const p = providers[key];
        if (!p) return;

        // Safe Icon Handling
        const iconValue = p.icon || 'fas fa-id-card';
        const isUrl = iconValue.indexOf('.') > -1 && !iconValue.includes(' ');

        // Safe Style Object
        const buttonStyle = {};
        if (p.btn_bg) buttonStyle.backgroundColor = p.btn_bg;
        if (p.btn_text) buttonStyle.color = p.btn_text;
        buttonStyle.border = 'none';

        // Add to List
        items.add(`oidc-${key}`, m(Button, {
          className: `Button LogInButton LogInButton--oidc LogInButton--${key}`,
          icon: isUrl ? null : iconValue,
          onclick: () => {
            window.location.href = authUrl(key);
          },
          style: buttonStyle
        }, isUrl && m("img", {
          src: iconValue,
          alt: "",
          className: "Button-icon",
          style: {
            height: '20px',
            verticalAlign: 'text-bottom',
            marginRight: '5px'
          }
        }), p.button_title || `Log in with ${key}`));
      });
    } catch (err) {
      console.error('Floxum OIDC Extension Error:', err);
    }
  });
  handleAuthRedirect();
});